module.exports = __webpack_public_path__ + "static/img/bg3.d144ed28.png";